export default {"src":"/_next/static/media/proxy.df0b7d71.svg","height":77,"width":623};